const SHIPPING_OPTIONS = {
    ALTERNATIVE: 'Alternative',
    BRINGDENMARK: 'BringDenmark',
    BUSSGODS: 'Bussgods',
    COMBINED_SHIPPING: 'CombinedShipping',
    DHL: 'DHL',
    FEDEX: 'FedEx',
    NOT_SPECIFIED: 'NotSpecified',
    POSTNORD: 'Posten',
    POSTNORD_PARCEL: 'PostNordParcel',
    POSTNORD_STAMP: 'PostNordStamp',
    SCHENKER: 'SchenkerPrivpak',
    TAKE_AWAY: 'Takeaway',
    TAKE_AWAY_ONLY: 'TakeawayOnly',
    UPS: 'Ups'
};

export default SHIPPING_OPTIONS;
